module.exports = __webpack_public_path__ + "static/media/portrait-1.72da74e1.jpg";